import React from 'react';
import ReactDOM from 'react-dom/client';
import FatigueLife from './FatigueLife';

const $root: HTMLElement | null = document.getElementById(
	'timken-tool-bearing-fatigue-life',
);

if ( $root ) {
	ReactDOM.createRoot( $root ).render(
		<React.StrictMode>
			<FatigueLife />
		</React.StrictMode>
	);
}
